require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-kay-burton-feature-paul-conrad-discussing-cities-closest-to-his-heart.json") })
        }
      }, "path---journal-kay-burton-feature-paul-conrad-discussing-cities-closest-to-his-heart");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-kay-burton-feature-paul-conrad-discussing-cities-closest-to-his-heart!./.cache/json/journal-kay-burton-feature-paul-conrad-discussing-cities-closest-to-his-heart.json
// module id = 505
// module chunks = 231608221292675